import type { Resource } from 'i18next';

import { i18nInitConfig } from '@readme/i18n';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

/**
 * Initialize an i18n instance for the React app and provision it with the
 * initial language and translation data from the server props.
 * This is used during both the SSR and CSR lifecycles to ensure that
 * translations are available rendered immediately.
 */
export function init(initialLanguage: string, initialData: Resource) {
  i18n.use(initReactI18next);
  i18n.init({
    ...i18nInitConfig,
    lng: initialLanguage,
    resources: initialData,
    // Because the language exists on the version route segment and the version
    // can only change on a full page load, we don't need i18next to fetch any
    // additional translation files after the app mounts.
    // IF we ever do, we can use this loadPath config for 'i18next-http-backend'
    // to point to a public locales dir.
    // backend: {
    //   loadPath: '/public/locales/{{lng}}/{{ns}}.json',
    // },
    react: { useSuspense: false },
  });
}

export default i18n;
